import {
  OrderUpdateRequestType,
  OrderUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useOrderUpdate = (orderId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: OrderUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `orders/${orderId}`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as OrderUpdateResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Orders, orderId],
      });
      // for now porter endpoint does return all the required fields to update lists
      // queryClient.setQueriesData<InfiniteData<Order[]>>(
      //   [business?.id, ServerStateKeys.Orders],
      //   (data) => {
      //     if (!data?.pages) return data;
      //     return {
      //       ...data,
      //       pages: data.pages.map((page) =>
      //         page.map((order) =>
      //           order.id === response.id ? response : order
      //         )
      //       ),
      //     };
      //   }
      // );
    },
  });
};
